import { AndOperatorLabel } from '@modules/analysis/components/DashboardAndAnalysisFiltersPreview/AndOperatorLabel';
import { DashboardOrAnalysisFiltersPreviewTitle } from '@modules/analysis/components/DashboardAndAnalysisFiltersPreview/DashboardOrAnalysisFiltersPreviewTitle';
import { WhereClausePreview } from '@modules/common/components/WhereClausePreview';

import { Box, Stack, alpha } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';

interface DashboardAndAnalysisFiltersPreviewProps {
  dashboardWhereClause: WhereClause;
  analysisWhereClause: WhereClause;
  shouldHideHeader?: boolean;
  shouldHideTooltips?: boolean;
  analysisUseCase: AnalysisUseCase;
}

export const DashboardAndAnalysisFiltersPreview = ({
  dashboardWhereClause,
  analysisWhereClause,
  shouldHideHeader = false,
  shouldHideTooltips = false,
  analysisUseCase,
}: DashboardAndAnalysisFiltersPreviewProps) => {
  return (
    <Stack
      sx={{
        borderRadius: 1,
      }}
    >
      <WhereClausePreview
        shouldHideTooltips={shouldHideTooltips}
        whereClause={dashboardWhereClause}
        valueTextColor="info.main"
        headerNode={
          shouldHideHeader ? null : (
            <DashboardOrAnalysisFiltersPreviewTitle isDashboardVariant />
          )
        }
        sxProps={{
          backgroundColor: (theme) =>
            theme.palette.misc.queryBuilder.dashboardFilter.bgColor,
          borderBottom: 'none',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderColor: (theme) => alpha(theme.palette.info.main, 0.5),
          pb: 1,
          py: 0,
        }}
      />
      {/* Add space for the AND operator */}
      <Box
        sx={{
          height: '10px',
          width: '100%',
          backgroundColor: (theme) =>
            theme.palette.misc.queryBuilder.dashboardFilter.bgColor,
          border: '1px solid',
          borderColor: (theme) => alpha(theme.palette.info.main, 0.5),
          borderTop: 'none',
          borderBottom: 'none',
        }}
      />
      <AndOperatorLabel />
      <WhereClausePreview
        shouldHideTooltips={shouldHideTooltips}
        whereClause={analysisWhereClause}
        headerNode={
          shouldHideHeader ? null : (
            <DashboardOrAnalysisFiltersPreviewTitle
              analysisUseCase={analysisUseCase}
              isDashboardVariant={false}
            />
          )
        }
        sxProps={{
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          pt: 1,
          py: 0,
        }}
      />
    </Stack>
  );
};
